import React from 'react'
import * as fnc from 'helpers/fnc'
import { IconButton } from './IconButton'
import { Button } from './Button'
import { useAdminPermissions, useAppDispatch, useAppSelector, useDocumentationLink } from 'app/hooks'
import { showDocumentationDialog } from 'actions/appActions'
import { AppData, UserRole } from 'app/types'

interface DocLinkButtonProps {
    docLink: string
    children?: React.ReactNode
    className?: string
    tooltip?: string
    [key: string]: any  // For other props
}

export function DocLinkButton({ docLink, className, tooltip, children, ...otherProps }: DocLinkButtonProps) {
    const dispatch = useAppDispatch()
    const project = useAppSelector((state) => state.app.projectCurrent[0])
    const organization = useAppSelector((state) => state.app.organization)

    function handleDocumentation(e) {
        dispatch(showDocumentationDialog({ docLink }))
    }

    const getDocumentation = useDocumentationLink()
    const documentation = getDocumentation(docLink)
    const finalTooltip = tooltip || 'View documentation'
    let finalClassName = className
    let missing = false
    if (!documentation) {
        finalClassName = `${className || ''} missing`
        missing = true
    }

    const adminPermissions = useAdminPermissions()
    if (missing && !adminPermissions(project, organization, [UserRole.DocumentationEdit])) {
        return null
    }

    if (children) {
        let title = children
        if (missing) {
            title = 'Documentation Unavailable'
        }
        return (
            <Button
                icon="fas fa-book"
                className={`doclink-button${finalClassName ? ` ${finalClassName}` : ''}`}
                tooltip={finalTooltip}
                {...otherProps}
                onClick={handleDocumentation}
            >
                {title}
            </Button>
        )
    }

    return (
        <IconButton
            icon="fas fa-book"
            className={`doclink-button${finalClassName ? ` ${finalClassName}` : ''}`}
            tooltip={finalTooltip}
            {...otherProps}
            onClick={handleDocumentation}
        />
    )
}

export default DocLinkButton